module.exports = {
    Buy_Equip_Success: "Buy_Equip_Success"
    , Open_View_Event: "Open_View_Event"
    , Buy_Success_Event: "Buy_Success_Event"
    , Get_Buy_list: "Get_Buy_list"
    , Buy_One_Success: "Buy_One_Success"
    , Get_Half_Discount: "Get_Half_Discount"
    , Frash_tips_event: "Frash_tips_event"
    , Score_Buy_List: "Score_Buy_List"
    , Hot_Buy_List: "Hot_Buy_List"
    , Artifact_Buy_List: "Artifact_Buy_List"
    , Artifact_Buy_Success: "Artifact_Buy_Success"
    , Free_Refresh_Data: "Free_Refresh_Data"
    , Update_Action_event: "Update_Action_event" //--活动商城的事件 获取所有活动信息
    , Buy_Action_Shop_Success_event: "Buy_Action_Shop_Success_event" //活动商品购买成功
};